import {useDispatch} from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import {useClientSessionsModal} from '../hooks'
import {setClientSessionsModal} from './sessionsSlice'
import Session from './Session'
import CenteredLoader from '../../CenteredLoader/CenteredLoader'

const ClientSessionsModal = ()=>{
	const dispatch = useDispatch()
	const {status,show,aggregates} = useClientSessionsModal()
	const onHide = ()=>{
		dispatch(setClientSessionsModal({
			show:false,
			client_id:null
		}))
	}

	return (
		<Modal 
			onHide={onHide}
			show={show}
			centered
		>
			{status==='pending'?
				<Modal.Body>
					<CenteredLoader/>
				</Modal.Body>
				:
				<>
					<Modal.Header>
						{aggregates?.client.name}'s Sessions
					</Modal.Header>
					<Modal.Body>
						<div className="d-flex justify-content-between">
							<strong>Date Added</strong>
							<strong>Status</strong>
						</div>
						<hr className="my-1"/>
						{aggregates?.sessions.map(
							session => <Session session={session} showName={false}/>
						)}
					</Modal.Body>
				</>
			}
		</Modal>
	)
}


export default ClientSessionsModal